<template>
  <div class="overallcontainer" oncontextmenu="return false">


    <router-view/>
  </div>
</template>
<script>
import $ from 'jquery'
export default {
  name: "app",
  created() {
    $(window).on('keydown',function(event){
      if(event.keyCode==123){
        return false;
      }else if(event.ctrlKey && event.shiftKey && event.keyCode==73){
        return false;
      }else if(event.ctrlKey && event.keyCode==73){
        return false;
      }
    });
  }
};
</script>
import Vuex from 'vuex';

Vue.use(Vuex);
 const store = new Vuex.Store({
  state: {
    employeeId: ''
  }
});

<style>

/* #nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
} */
body {
  background-color: #F0F2F5 !important;
}
</style>
